import { GoogleSearch, MainFocus, WelcomeMsg } from "../components"
export const AfterOnboarding =()=>{
    return(
        <>
        <WelcomeMsg />
        <GoogleSearch />
        <MainFocus />
        </>
    )
}